import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rep-ledger',
  templateUrl: './rep-ledger.component.html',
  styleUrls: ['./rep-ledger.component.css']
})
export class RepLedgerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
